// Libs
import { ReactElement } from 'react';
import clsx from 'clsx';
import { Stack, useMediaQuery, useTheme } from 'ui-components';
// App
import styles from './page.module.scss';
import { PageProps } from './page.interfaces';
import LeftPanel from '../left-panel';
import Header from '../header';
import PageBody from '../page-body';

const Page = (props: PageProps): ReactElement => {
  const { children, className } = props;
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <div className={clsx(styles.page, className)}>
      {isSmallScreen && <Header />}
      <Stack direction="row">
        {!isSmallScreen && <LeftPanel shouldShowMenu={true} />}
        <PageBody>{children}</PageBody>
      </Stack>
    </div>
  );
};

export default Page;
